import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Accent, SectionHeading } from './SectionHeading';
export function TestimonialsSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 sm:pb-16" aria-labelledby="testimonios-titulo" data-id="element-179" data-mp="1n0k8tjlmtq96">
      <div className="mx-auto max-w-4xl" data-id="element-180" data-mp="1r146coa4avvu">
        <SectionHeading id="testimonios-titulo" badge="Testimonios" badgeIcon={StarIcon} title={<>
              Lo Que Dicen <Accent data-id="element-182" data-mp="1d47eqkm6dadw">Quienes Ya lo Tienen</Accent>
            </>} data-id="element-181" data-mp="1qzt1el4xri35" />

        <ul className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-183" data-mp="1i1qvbr6chz90">
          {testimonials.map(({
          quote,
          initials,
          name,
          role
        }) => <li key={name} className="flex h-full flex-col rounded-2xl border border-cream-300/70 bg-cream-50 p-6" data-id="element-184" data-mp="182i599elp4rx">
              <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-185" data-mp="2yexrma1j3fic">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-ember-400 text-ember-400" aria-hidden="true" data-id="element-186" data-mp="32frer175cqa6" />)}
              </span>
              <blockquote className="mt-4 text-sm leading-relaxed text-forest-700/80" data-id="element-187" data-mp="2uzrkd6oxdlmp">“{quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-188" data-mp="2q0eyao5voil6">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-forest-600 text-xs font-bold text-cream-50" data-id="element-189" data-mp="34q2oat8lzutl">
                  {initials}
                </span>
                <div data-id="element-190" data-mp="2c3rohksttxxu">
                  <p className="text-sm font-semibold text-forest-800" data-id="element-191" data-mp="2c38eqrdbyfuw">{name}</p>
                  <p className="text-xs text-forest-700/60" data-id="element-192" data-mp="274or8mj38w0f">{role}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}